import { Component } from '@angular/core';

@Component({
  selector: 'app-font-loader',
  templateUrl: './font-loader.component.html',
  styleUrl: './font-loader.component.scss',
})
export class FontLoaderComponent {}
